import React from 'react'
import { withLocalize } from 'react-localize-redux'
import { setLocale } from 'utils/localstorage'
import { Box, Grid, Button } from '@material-ui/core'
import { styled } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import usePermission from 'hooks/usePermission'
import PERMISSIONS from 'constants/permissions'

const ActiveButton = styled(Button)(({ theme, active }) => ({
  backgroundColor: active
    ? theme.palette.primary.main
    : theme.palette.grey[300],
  color: active ? theme.palette.common.white : theme.palette.common.black,
  '&:hover': {
    backgroundColor: active
      ? theme.palette.primary.main
      : theme.palette.grey[400],
  },
}))

const LanguageSelectorForAdmins = ({ languages, setActiveLanguage }) => {
  const canUpdateClub = usePermission(PERMISSIONS.UPDATE_CLUB, 'club')

  return (
    <>
      {canUpdateClub && (
        <Grid container>
          {languages.map(({ code, name, active }) => (
            <Box key={code} m={1}>
              <ActiveButton
                variant="contained"
                active={active}
                onClick={() => {
                  setActiveLanguage(code)
                  setLocale(code)
                }}
              >
                {name}
              </ActiveButton>
            </Box>
          ))}
        </Grid>
      )}
    </>
  )
}

LanguageSelectorForAdmins.propTypes = {
  languages: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      active: PropTypes.bool.isRequired,
    })
  ).isRequired,
  setActiveLanguage: PropTypes.func.isRequired,
}

export default withLocalize(LanguageSelectorForAdmins)
